/**
 * Get the current time from the server and return a date object.
 *
 * @returns The current date from the server
 * @category Utils
 */
export default async () => {
  const serverTime = await $fetch<{ timestamp: number }>('/fapi/server/time')
  return serverTime?.timestamp ? new Date(serverTime.timestamp) : new Date(0)
}
